module.exports = __webpack_public_path__ + "img/GroupN5.d80fde75.png";